import { render, staticRenderFns } from "./PersonBlock.vue?vue&type=template&id=1e5a256c"
import script from "./PersonBlock.vue?vue&type=script&lang=js"
export * from "./PersonBlock.vue?vue&type=script&lang=js"
import style0 from "./PersonBlock.vue?vue&type=style&index=0&id=1e5a256c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports